import { createAction, props } from '@ngrx/store';
import {
  IngredientAssociation,
  IngredientAssociationAiApplyInput,
  IngredientAssociationAiApplyResponse,
  IngredientAssociationAiLanguage,
  IngredientAssociationAiSuggestion,
} from '../../../shared/models/ingredientAssociation.model';


// LOAD (optionally filtered)
export const loadIngredientAssociations = createAction(
  '[IngredientAssoc] Load All',
  props<{ fromId?: number }>() // optional filter
);

export const loadIngredientAssociationsSuccess = createAction(
  '[IngredientAssoc] Load All Success',
  props<{ associations: IngredientAssociation[] }>()
);

export const loadIngredientAssociationsFailure = createAction(
  '[IngredientAssoc] Load All Failure',
  props<{ error: any }>()
);

// ADD
export const addIngredientAssociation = createAction(
  '[IngredientAssoc] Add',
  props<{
    from_ingredient_id: number;
    to_ingredient_id: number;
    strength: number;
    ratio: string;
    note?: string | null;
  }>()
);

export const addIngredientAssociationSuccess = createAction(
  '[IngredientAssoc] Add Success',
  props<{ association: IngredientAssociation }>()
);

export const addIngredientAssociationFailure = createAction(
  '[IngredientAssoc] Add Failure',
  props<{ error: any }>()
);

// UPDATE
export const updateIngredientAssociation = createAction(
  '[IngredientAssoc] Update',
  props<{
    association_id: number;
    changes: {
      from_ingredient_id?: number;
      to_ingredient_id?: number;
      strength?: number;
      ratio?: string;
      note?: string | null;
    };
  }>()
);

export const updateIngredientAssociationSuccess = createAction(
  '[IngredientAssoc] Update Success',
  props<{ association: IngredientAssociation }>()
);

export const updateIngredientAssociationFailure = createAction(
  '[IngredientAssoc] Update Failure',
  props<{ error: any }>()
);

// DELETE
export const deleteIngredientAssociation = createAction(
  '[IngredientAssoc] Delete',
  props<{ association_id: number }>()
);

export const deleteIngredientAssociationSuccess = createAction(
  '[IngredientAssoc] Delete Success',
  props<{ association_id: number }>()
);

export const deleteIngredientAssociationFailure = createAction(
  '[IngredientAssoc] Delete Failure',
  props<{ error: any }>()
);

// RESET (clear state on logout / navigation etc.)
export const resetIngredientAssociations = createAction(
  '[IngredientAssoc] Reset State'
);

export const generateIngredientAssociationsWithAi = createAction(
  '[IngredientAssoc AI] Generate',
  props<{ ingredient_id: number; language: IngredientAssociationAiLanguage }>()
);

export const generateIngredientAssociationsWithAiSuccess = createAction(
  '[IngredientAssoc AI] Generate Success',
  props<{ suggestions: IngredientAssociationAiSuggestion[]; conceptCount: number }>()
);

export const generateIngredientAssociationsWithAiFailure = createAction(
  '[IngredientAssoc AI] Generate Failure',
  props<{ error: any }>()
);

export const applySelectedIngredientAssociations = createAction(
  '[IngredientAssoc AI] Apply Selected',
  props<{ associations: IngredientAssociationAiApplyInput[] }>()
);

export const applySelectedIngredientAssociationsSuccess = createAction(
  '[IngredientAssoc AI] Apply Selected Success',
  props<{ result: IngredientAssociationAiApplyResponse }>()
);

export const applySelectedIngredientAssociationsFailure = createAction(
  '[IngredientAssoc AI] Apply Selected Failure',
  props<{ error: any }>()
);
